export default [
  {
    text: 'Network name',
    value: 'name',
    width: '240px',
  },
  {
    text: 'Type',
    value: 'type.name',
    sortable: false,
    width: '160px',
  },
  {
    text: 'Tracking link',
    value: 'tracking_link',
    sortable: false,
  },
];
